module.exports = __webpack_public_path__ + "static/media/SQS.1574f5b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SQS.svg
// module id = 294
// module chunks = 0